import { makeStyles } from '@mui/styles';

const useStyles: any = makeStyles((theme: any) => ({
  buttonStyle: {
    width: "200px",
    height: "40px",
    borderRadius: "4px",
    background: theme.gradiants.button,
    fontFamily: "Roboto",
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "normal",
    color: "#fdfdfe",
    margin: 0,
    marginBottom: "15px",
    padding: 0
  },
  resetButtonStyle: {
    height: "40px",
    borderRadius: "4px",
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "normal",
    color: theme.palette.error.main,
    border: `1px solid ${theme.palette.error.main}`,
    marginBottom: "15px",
    marginInlineEnd: "12px",
    textTransform: "none"
  },
  buttonsContainer: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center"
  },
  segment: {
    marginBottom: "36px"
  },
  segmentHeader: {
    marginBottom: "16px",
    paddingBottom: "12px",
    borderBottom: `1px solid ${theme.tables.headerCell.backgroundColor}`
  },
  segmentTitle: {
    fontFamily: "Roboto",
    fontSize: "20px",
    fontWeight: 600,
    color: theme.tables.headerCell.color,
    marginBottom: "6px"
  },
  segmentSubtitle: {
    fontFamily: "Roboto",
    fontSize: "14px",
    lineHeight: 1.5,
    color: "#79797d",
    maxWidth: "560px"
  },
  tableHead: {
    height: "45px"
  },
  headCells: {
    border: "none",
    borderBottom: "none",
    color: theme.tables.headerCell.color,
    fontWeight: theme.tables.headerCell.fontWeight,
    fontFamily: theme.tables.headerCell.fontFamily,
    lineHeight: theme.tables.headerCell.lineHeight,
    letterSpacing: theme.tables.headerCell.letterSpacing,
    backgroundColor: theme.tables.headerCell.backgroundColor,
    textTransform: theme.tables.headerCell.textTransform,
    height: 45,
    fontSize: 13
  },
  rowCell: {
    fontFamily: theme.tables.tableCell.fontFamily,
    color: theme.tables.tableCell.color,
    fontSize: theme.tables.tableCell.fontSize,
    padding: theme.tables.tableCell.padding
  },
  expandCell: {
    width: "40px",
    padding: 0
  },
  copyableCell: {
    display: "flex",
    alignItems: "center",
    gap: "4px"
  },
  expandIconOpen: {
    transform: "rotate(180deg)"
  },
  hierarchyCell: {
    padding: 0,
    borderBottom: "none"
  },
  paperPadding: {
    padding: "20px 21px",
    maxHeight: "calc(100% - 130px)",
    display: "flex",
    flexFlow: "column nowrap",
    minHeight: "250px"
  },
  inputRoot: {
    color: "white",
    fontFamily: "Roboto",
    fontSize: "13px",
    width: "300px",
    display: "flex",
    flexDirection: "row",
    height: "36px",
    borderRadius: "4px",
    padding: "0 15px",
    backgroundColor: "rgba(170, 162, 170, 0.3)",
    maxWidth: "70%",
    marginRight: "40px"
  },
  searchAdorment: {
    marginLeft: "-10px",
    marginRight: "12px"
  },
  searchIcon: {
    transform: "scale(0.7)"
  },
  closeIconStyle: {
    color: "white",
    padding: "7px",
    "& svg": {
      fontSize: "24px"
    }
  },
}));
export default useStyles;
